<template lang="pug">
div(id="search-box" class="tw-w-full")
  v-autocomplete(
    ref="search-global"
    solo
    rounded
    flat
    single-line
    no-filter
    hide-no-data
    elevation="0"
    append-icon=""
    prepend-inner-icon="mdi-magnify"
    class="pt-7 px-5 "
    v-model="query"
    item-text="_source.name"
    @focus="active = true"
    @blur="active = false"
    :class="active && results.length > 0 ? 'search-box' : active ? 'search-box-no-results' : results.length > 0 ? 'search-box' : ''"
    :search-input.sync="search"
    :items="results"
    :menu-props="{ contentClass: 'search-menu', rounded: 'rounded-b-xl', closesOnContentClick: true, nudgeTop: '1' }"
  )
    template(v-slot:selection="data")
      span {{ data.item._source.name }}
    template(v-slot:item="data")
      v-list-item(link @click="to(data.item)")
        core-search-bar-item(:item="data.item")
</template>
<script>
export default {
  data() {
    return {
      result: [],
      query: '',
      search: '',
      results: [],
      active: false,
    };
  },
  watch: {
    search(query) {
      query && query != this.query && this.getResults(query);
    },
  },
  methods: {
    getResults(query) {
      this.$http
        .get('/search?query=' + query)
        .then((response) => {
          this.results = response.data.hits.hits;
        })
        .catch((error) => {
          this.results = [];
          this.$store.commit('SET_ERROR', error);
        });
    },
    to(item) {
      this.results = [];
      this.active = false;
      if (item._index.includes('contacts')) {
        this.$router.push('/contacts/' + item._source.id);
      }
      if (item._index.includes('properties')) {
        this.$router.push('/listings/' + item._source.id);
      }
    },
  },
};
</script>
<style>
/* #search-box .v-input__control .v-input__slot {
  border-radius: 20px 20px 0px 0px;
} */
.search-box .v-input__control .v-input__slot {
  border-radius: 24px 24px 0px 0px;
  box-shadow: 0 4px 6px 0 rgba(32, 33, 36, 0.28);
}
.search-box-no-results .v-input__control .v-input__slot {
  box-shadow: 0 4px 6px 0 rgba(32, 33, 36, 0.28);
}
.search-menu {
  border-radius: 0 0 24px 24px !important;
}
</style>
